// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // https://dev-smartparking.bizzdev.net/api/swagger/index.html

  // apiUrl: 'https://localhost:44360',

  // apiDomain: `https://localhost:44361`,
  // identityApiUrl: 'https://localhost:44361/',
  // whiteListedUrl: `https://localhost:44360/api`,
  // socialBlackListedUrl: 'https://localhost:44360/api/user/socials/login',
  // blacklistedUrl: `https://localhost:44361/Identity`,

  // DEV

  // apiUrl: 'https://dev-smarthub.bizzdev.net/api',

  // apiDomain: 'dev-smarthub.bizzdev.net',
  // identityApiUrl: 'https://dev-smarthub.bizzdev.net/identity/',
  // whiteListedUrl: 'https://dev-smarthub.bizzdev.net/api',
  // socialBlackListedUrl:
  //   'https://dev-smarthub.bizzdev.net/api/user/socials/login',
  // blacklistedUrl: 'https://dev-smarthub.bizzdev.net/identity/',

  // QUAL

  apiUrl: 'https://qual-smarthub.bizzdev.net/api',

  apiDomain: 'qual-smarthub.bizzdev.net',
  identityApiUrl: 'https://qual-smarthub.bizzdev.net/identity/',
  whiteListedUrl: 'https://qual-smarthub.bizzdev.net/api',
  socialBlackListedUrl:
    'https://qual-smarthub.bizzdev.net/api/user/socials/login',
  blacklistedUrl: 'https://qual-smarthub.bizzdev.net/identity/',

  // apiUrl: 'https://smarthub.bizzdev.net/api',

  // apiDomain: 'smarthub.bizzdev.net',
  // identityApiUrl: 'https://smarthub.bizzdev.net/identity/',
  // whiteListedUrl: 'https://smarthub.bizzdev.net/api',
  // socialBlackListedUrl: 'https://smarthub.bizzdev.net/api/user/socials/login',
  // blacklistedUrl: 'https://smarthub.bizzdev.net/identity/',

  tokenKey: 'bizz-smarthub-token-admin',
  tokenExpKey: 'bizz-smarthub-token-exp-admin',
  rfTokenKey: 'bizz-smarthub-rf-token-admin',

  language: 'language', // clés session storage
  editable: 'editable',
  directoryModel: 'directoryModel',
  wordSearched: 'wordSearched',
  project: 'project',

  // bizzmine
  bizzmineUrl: 'https://bizzmine.bizzdev.net/login?projectinfo=',
  bizzmineApiKey: '0aff1c279d3332e7ca037a4d6e1d014424128d46',
  bizzmineProjectName: 'SmartWaste',
  customFieldClientSmartWaste: 134,

  appName: 'SmartHub',
  version: require('../../package.json').version,

  localTranslations: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
